import { VariavelSimulacao } from './variavel-simulacao';

export class SimulacaoEstrutura {
  variaveis: VariavelSimulacao[];
  idFornecedor?: number;
  telhado?: number;
  orientacao?: number;
}
